import React from 'react';
import PropTypes from 'prop-types';
import WidgetErrorMessage from '../../WidgetErrorMessage';
import {
    getMetricSourcesForRequests,
    hasMetricSources,
    allMetricSourcesAuthorized,
    getMetricSourceErrors,
    displayMetricSourceError,
} from '../../utils/wrapperUtils';
import SankeyChart from './SankeyChart';
import { getFormattedTimeFromMilliseconds } from '../../utils/dataFormatUtils';
import { formatSankeyMetricSeries } from './sankeyDataFormatUtils';

// eslint-disable-next-line complexity
function getMetricSource({ metricRequests, metrics }) {
    if (metricRequests.length !== 1 || metricRequests[0].metrics.length !== 3) {
        return { errorKey: 'invalidMetricRequests' };
    }

    const metricSources = getMetricSourcesForRequests(metrics, metricRequests);
    if (metricSources.some((metricSource) => !metricSource)) {
        return { errorKey: 'metricSourceNotFound' };
    }

    if (!allMetricSourcesAuthorized(metricSources, false)) {
        return { errorKey: 'metricSourceUnauthorized' };
    }

    if (!hasMetricSources(metricSources, false)) {
        return { errorKey: 'missingData' };
    }

    const metricSourceErrors = getMetricSourceErrors(
        metricSources,
        metricRequests
    );
    if (metricSourceErrors.length) {
        return { metricSourceErrors };
    }

    return { metricSources, metricRequests };
}

// eslint-disable-next-line complexity
export default function SankeyChartWrapper(props) {
    const { metricSources, metricRequests, metricSourceErrors, errorKey } =
        getMetricSource(props);

    if (errorKey) {
        return (
            <WidgetErrorMessage>
                {props.dashboardLabels[errorKey]}
            </WidgetErrorMessage>
        );
    }

    if (metricSourceErrors) {
        return metricSourceErrors.map((error) => (
            <WidgetErrorMessage key={error.uniqueRequestString}>
                {displayMetricSourceError(error, props.dashboardLabels)}
            </WidgetErrorMessage>
        ));
    }

    const formattedData = formatSankeyMetricSeries(
        metricSources[0].metricSeries,
        metricRequests[0].metrics
    );

    const formatter = props.configuration.isTime
        ? getFormattedTimeFromMilliseconds
        : undefined;

    if (!formattedData.links.length || !formattedData.nodes.length) {
        return null;
    }

    return (
        <SankeyChart
            {...props}
            chartProperties={props.configuration}
            dataFormatter={formatter}
            dataPoints={formattedData}
        />
    );
}

SankeyChartWrapper.propTypes = {
    configuration: PropTypes.instanceOf(Object).isRequired,
    dashboardLabels: PropTypes.instanceOf(Object).isRequired,
    numberDecimalFormatter: PropTypes.func.isRequired,
};
